import React, { useEffect } from "react";
import DMSHeader from "../../DMSHeader/DMSHeader";
//import DailyFloodReportCompTable from "./DailyFloodReportCompTable";
import { useTranslation } from "react-i18next";
import DailyAvalancheReportForm from "./DailyAvalancheReportForm";
import "../ReportEnhanced.css";

const DailyAvalancheReport = () => {
  const { t } = useTranslation();

  return (
    <div className="report-enhanced-wrapper">
      <div className="report-header-enhanced">
        <DMSHeader title="Avalanche Daily Report" />
      </div>
      <div className="report-table-enhanced">
        <DailyAvalancheReportForm />
      </div>
    </div>
  );
};

export default DailyAvalancheReport;
